const GET_PRODUCT_LIST_BY_CATEGORY = 'GET_PRODUCT_LIST_BY_CATEGORY';
const CLEAR_PRODUCT_LIST = 'CLEAR_PRODUCT_LIST';
const IS_PRODUCT_LIST_SERVER_API_CALLED = 'IS_PRODUCT_LIST_SERVER_API_CALLED';

export { GET_PRODUCT_LIST_BY_CATEGORY, CLEAR_PRODUCT_LIST, IS_PRODUCT_LIST_SERVER_API_CALLED }